import {LogLevel} from "../app/core/services/logger/log-level.enum";
import {LOG_LEVEL, LOGGER_PROVIDERS} from "../app/core/injection-tokens";
import {LogConsoleService} from "../app/core/services/logger/logger-providers/log-console-service/log-console.service";

const API_URL = "https://api-h2adhbejathxa7g6.a02.azurefd.net:443/dev/ssba-backend";

export const environment = {
  production: false,
  apiUrl: API_URL + '/v1',
  stage: "dev",
  useMockAuth: false,
  providers: [
    {provide: LOG_LEVEL, useValue: LogLevel.DEBUG},
    {provide: LOGGER_PROVIDERS, useClass: LogConsoleService, multi: true}
  ],
  msalConfig: {
    auth: {
      clientId: '4c82476b-79cd-4f87-8352-5c6505d53efa',
      authority: 'https://login.microsoftonline.com/3dca0b76-948c-4cb0-ba1c-6905087ac6ac',
    },
    redirectUri: '/',
  },
  apiConfig: {
    scopes: ['api://ssba-dev-backend/Access.Backend'],
    uri: API_URL
  },
  tenantId: '3dca0b76-948c-4cb0-ba1c-6905087ac6ac'
};
